export default __webpack_public_path__ + "static/media/newsroomTheme.f7a2edc8.png";